module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "i-upload-inner",
    class: {
      'i-dragger': _vm.type === 'drag',
        'is-dragOver': _vm.dragOver,
        'is-showCover': _vm.showCover
    },
    on: {
      "click": _vm.handleClick,
      "drop": function($event) {
        $event.preventDefault();
        _vm.onDrop($event)
      },
      "dragover": function($event) {
        $event.preventDefault();
        _vm.dragOver = true
      },
      "dragleave": function($event) {
        $event.preventDefault();
        _vm.dragOver = false
      }
    }
  }, [(!_vm.showCover) ? _vm._t("default") : _c('cover', {
    attrs: {
      "image": _vm.lastestFile,
      "on-preview": _vm.onPreview,
      "on-remove": _vm.onRemove
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    staticClass: "i-upload-input",
    attrs: {
      "type": "file",
      "multiple": _vm.multiple,
      "accept": _vm.accept
    },
    on: {
      "change": _vm.handleChange
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-21a7fca6!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/upload/src/upload.vue
// module id = 623
// module chunks = 0